import React, { useContext, useEffect, useState } from 'react';
import { CButton, CCard, CCardHeader, CCol, CRow, CModal, CModalHeader, CModalBody, CModalFooter } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import DownloadExcel from 'src/reusables/DownloadExcel';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';
import { getAll } from 'src/services/PurchaseOrders';
import { Toaster } from 'src/components/Toaster';
import ls from 'local-storage';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import { AuthContext } from 'src/App';
function PurchaseOrders() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [color, setColor] = useState('');
  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.purchaseOrders &&
      res.purchaseOrders.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          poNumber: item.po_number,
          supplierID: item.address,
          uuid: item.uuid,
          supplierName: item.supplierName,
          poDate: formatter('dateOnly', item.po_date),
          notes: item.notes,
          receivedAt: item.received_at,
          grandTotal: formatter('currency', item?.grand_total ?? 0)
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width: '50' },
      { field: 'poDate', headerName: 'Tanggal PO', flex: 1 },
      { field: 'poNumber', headerName: 'Nomor PO', flex: 1 },
      { field: 'supplierName', headerName: 'Supplier', flex: 1 },
      { field: 'grandTotal', headerName: 'Total', flex: 1 },
      { field: 'notes', headerName: 'Catatan', flex: 1 },
      { field: 'receivedAt', headerName: 'Tanggal Diterima', flex: 1 }
    ];

    setDataColumns(columns);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/purchase-order-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? 'red'} />

      <CCard>
        <CCardHeader>
          <CRow className="mb-3">
            <CCol xs={7} lg={7}>
              <h4> Daftar Purchase Order </h4>
            </CCol>
            <CCol xs={5} lg={5} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/purchase-order-actions');
                }}
              >
                Tambah
              </CButton>
              &nbsp;
              {/* {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
                <DownloadExcel
                  rows={dataRows}
                  columns={dataColumns}
                  excelName="Daftar Produk"
                  config={{ width: '20' }}
                />
              )} */}
              <DownloadExcel
                rows={dataRows}
                columns={dataColumns}
                excelName="Daftar PurchaseOrder"
                config={{ width: '20' }}
              />
            </CCol>
          </CRow>
        </CCardHeader>
        <div style={{ margin: '16px' }}>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default PurchaseOrders;
